"use client";

import { Box, Container } from "@mui/material";
import { keyframes } from "@mui/system";
import Image from "next/image";
import { IMAGES } from "../constants/images";
const float = keyframes`
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-15px) rotate(3deg);
  }
`;

export default function WaveAnimation() {
  return (
    <Container
      maxWidth={false} // ✅ full-width container
      disableGutters // ✅ removes left/right padding
      sx={{ py: 1, mt: "-5%" }} // only top/bottom padding remains
    >
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "220px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
        }}
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 1200 200"
          preserveAspectRatio="none"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 1,
          }}
        >
          <defs>
            <linearGradient id="waveGradient" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stopColor="#7C3AED" stopOpacity="0.4" />
              <stop offset="50%" stopColor="#7C3AED" stopOpacity="0.9" />
              <stop offset="100%" stopColor="#7C3AED" stopOpacity="0.4" />
            </linearGradient>
          </defs>

          <path
            d="M0,100 Q300,60 600,100 T1200,100"
            stroke="url(#waveGradient)"
            strokeWidth="3"
            fill="none"
            strokeLinecap="round"
          >
            <animate
              attributeName="d"
              dur="2s"
              repeatCount="indefinite"
              values="
                M0,100 Q300,80 600,100 T1200,100;
                M0,100 Q300,120 600,100 T1200,100;
                M0,100 Q300,80 600,100 T1200,100
              "
              keyTimes="0; 0.5; 1"
              calcMode="spline"
              keySplines="0.42 0 0.58 1; 0.42 0 0.58 1"
            />
          </path>
        </svg>

        {/* Center Logo */}
        <Box
          sx={{
            position: "absolute",
            left: "50%",
            top: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 3,
          }}
        >
          <Box
            sx={{
              width: { xs: 90, sm: 0, md: 120 }, // 0 on xs and sm, 120px on md and up
              height: { xs: 90, sm: 0, md: 120 }, // 0 on xs and sm, 120px on md and up

              borderRadius: "50%",
              border: "3px solid #7C3AED",
              bgcolor: "white",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "transform 0.4s ease",
              "&:hover": {
                transform: "scale(1.1)",
              },
            }}
          >
            <Image
              src={IMAGES.WAVE_ANIMATION_LOGO}
              alt="Getgeek AI recruiting tool and video interview software logo"
              width={80}
              height={80}
              style={{
                objectFit: "contain",
              }}
            />
          </Box>
        </Box>
      </Box>
    </Container>
  );
}
